/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
'use strict';
define(['es6-promise'], function(promise) {

    //This is pollyfill for old IE trim method
    if (typeof String.prototype.trim !== 'function') {
        String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g, '');
        };
    }

    /**
     * @ignore
     * DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
     * Version 2, December 2004
     *
     * Copyright (C) 2011 Alex Kloss <alexthkloss@web.de>
     *
     * Everyone is permitted to copy and distribute verbatim or modified
     * copies of this license document, and changing it is allowed as long
     * as the name is changed.
     *
     * DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
     * TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION
     *
     * 0. You just DO WHAT THE FUCK YOU WANT TO.
     */

    if (![].indexOf) {
        Array.prototype.indexOf = function(a, b, c) {
            for (c = this.length, b = (c + ~~b) % c; b < c && (!(b in this) || this[b] !== a); ++b) {
                //do nothing
            }
            return b ^ c ? b : -1;
        };
    }

    if (![].forEach) {
        Array.prototype.forEach = function(a, b, c, d) {
            for (d = this.length, c = 0; c < d; ++c) {
                if (c in this) {
                    a.call(b, this[c], c, this);
                }
            }
        };
    }

    if (window.Promise === undefined) {
        window.Promise = promise;
    }

    Number.isInteger = Number.isInteger || function(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };

    //Object.assign - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
    //eslint-disable-next-line eqeqeq
    if (typeof Object.assign != 'function') {
        //eslint-disable-next-line no-unused-vars
        Object.assign = function(target, varArgs) { // .length of function is 2
            var to, index, nextSource, nextKey;
            //eslint-disable-next-line eqeqeq
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            to = Object(target);

            for (index = 1; index < arguments.length; index++) {
                nextSource = arguments[index];
                //eslint-disable-next-line eqeqeq
                if (nextSource != null) { // Skip over if undefined or null
                    for (nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        };
    }
});



// WEBPACK FOOTER //
// ./polyfills.js